import { Component, OnInit, ViewContainerRef } from '@angular/core';
import { MdDialog, MdDialogConfig, MdDialogRef } from '@angular/material';
import { plainToClass } from 'class-transformer';
import { RuleParamService } from './../rule-param.service';
import { RuleParam, RuleParamDataType } from './ruleparam.model';
import { AddRuleParamComponent } from '../addruleparam/add-ruleparam.component';
import { SnackBarService } from 'app/services/snackbar.service';
import { MessageService } from 'app/services/messages.service';
import { TrackingService } from 'app/shared/services/tracking/google-analytics-events.service';
import { TrackingConstants } from 'app/shared/services/tracking/tracking-constants.service';

@Component({
    selector: 'ruleparam-list',
    templateUrl: './ruleparam-list.component.html',
    styleUrls: ['./ruleparam-list.component.css']
})

export class RuleParamListComponent implements OnInit {
    ruleparamlist: RuleParam[];
    dataType: RuleParamDataType[];
    dialogRef: MdDialogRef<any>;
    selectedRuleParam: RuleParam;
    isLoading = true;

    constructor(
        public dialog: MdDialog,
        public viewContainerRef: ViewContainerRef,
        private ruleParamService: RuleParamService,
        private snackBarService: SnackBarService,
        private trackingService: TrackingService
    ) { }

    ngOnInit() {
        this.getRuleParamList();
        this.getRuleParamDataTypeList();
    }

    getRuleParamList() {
        this.ruleParamService.getRuleParam()
            .subscribe(response => {
                this.ruleparamlist = response;
                this.isLoading = false;
            });
    }
    getRuleParamDataTypeList() {
        this.ruleParamService.getRuleParamDatatype()
            .subscribe(response => {
                this.dataType = response;
            });
    }
    openAddRuleParamDialog(action: string) {
        let config = new MdDialogConfig();
        config.viewContainerRef = this.viewContainerRef;
        this.dialogRef = this.dialog.open(AddRuleParamComponent, config);
        this.dialogRef.componentInstance.selectedRuleParam = this.selectedRuleParam;
        this.dialogRef.componentInstance.arrDataType = this.dataType;
        this.dialogRef.componentInstance.action = action;
        this.dialogRef.afterClosed().subscribe(result => {
            this.dialogRef = null;
            if (result) {
                if (this.selectedRuleParam) {
                    this.ruleparamlist.splice(this.ruleparamlist.indexOf(this.selectedRuleParam), 1);
                }
                this.ruleparamlist.push(result);
            }
            this.selectedRuleParam = null;
        });
    }

    editRuleParameter(value: RuleParam): void {
        this.selectedRuleParam = value
        this.openAddRuleParamDialog('Edit');
    }
    deleteRuleParameter(ruleParam: RuleParam): void {
        this.ruleParamService.deleteRuleParam(ruleParam.id).subscribe(response => {
            if (response.flagResult) {
                this.ruleparamlist.splice(this.ruleparamlist.indexOf(ruleParam), 1);
            }
            this.trackingService.emitEvent(TrackingConstants.RULE_PARAM_MANAGEMENT, TrackingConstants.DELETE_RULE_PARAM, TrackingConstants.SUCCESS, 1);
            this.callSnackBarService(response, MessageService.DELETE_RULE_PARAM_SUCCESS, MessageService.DELETE_RULE_PARAM_FAILURE);
        }, err => {
            this.trackingService.emitEvent(TrackingConstants.RULE_PARAM_MANAGEMENT, TrackingConstants.DELETE_RULE_PARAM,
                TrackingConstants.FAILURE, 0);
            this.callSnackBarService(err, MessageService.DELETE_RULE_PARAM_FAILURE, MessageService.DELETE_RULE_PARAM_FAILURE);
        });
    }

    callSnackBarService(response: any, successMsg: string, failureMsg: string) {
        this.snackBarService
            .showStatus(response,
            successMsg,
            failureMsg);
    }
}



// WEBPACK FOOTER //
// ./src/app/admin/rules/ruleparamlist/ruleparam-list.component.ts